import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { getErrorsMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
import SimplePagination from "./SimplePagination";
class DashboardAdminPerson extends Component {
    static contextType = LangContext;

    constructor(props) {
        super(props);
        this.state = {
            data: null,
            companies: [],
            accountTypes: [],
            usersPerson:[],
            providers:[],
            AccountTypePersonHistory:[],
            accountTypeData:[],
            profiles:[],
            status:'',
            fileRetention: false ,
            comment: '',
        };
    }

       // Capturar el cambio en el campo de comentario
    handleCommentChange = (event) => {
        this.setState({ comment: event.target.value });
    }
    handleCheckboxChange = (event) => {
        this.setState({ fileRetention: event.target.checked });
    }
    getPersonData = async () => {
        const { instance, personid } = this.props; // Obtener las props
        const url = '/api/get_person_data';
        await axios.post(url, {
            instance: instance,
            id: personid,
        }).then(res=>{
            console.log('x')
            console.log(res.data)
            this.setState({
                data: res.data.person,
                companies: res.data.companies || [],
                accountTypes: res.data.accountTypes,
                usersPerson:res.data.usersPerson,
                providers:res.data.providers,
                AccountTypePersonHistory:res.data.AccountTypePersonHistory,
                accountTypeData:res.data.accountTypeData,
                status:res.data.status,
                fileRetention: res.data.person.latestAccountTypePerson.file_retention == 1 ,
                comments:res.data.comments
            });
        });  
    }
    handleStatusChange = (event) => {
        this.setState({ status: event.target.value });
    }
    handleSubmitComment = async (event) => {
        event.preventDefault();
        const { status , fileRetention,comment} = this.state; 
        const { instance, personid } = this.props;
        const url = `/api/admin/update_person`;

        try {
            await axios.post(url, {
                instance: instance,
                id: this.state.data.id,
                lastestId : this.state.data.latestAccountTypePerson.id,
                status: status,
                account_type_id: event.target.account_type_id.value,
                file_retention: fileRetention ? 1 : 0,
                comment: comment,  
            });
            // Handle success (e.g., show a success message)
        } catch (error) {
            // Handle error (e.g., show an error message)
        }
    }
    async getProfiles(){
        axios.get('/api/profiles-people').then(res=>{
            console.log(res)
            this.setState({profiles:res.data}) 
        })
    }
    async componentDidMount() {   

        await this.getProfiles();  
        await this.getPersonData(); 
    }
    handleSubmit = async (event) => { 
        event.preventDefault();
        const { status , fileRetention,comment} = this.state; 
        const { instance, personid } = this.props;
        const url = `/api/admin/update_person`; 
        try {
            await axios.post(url, {
                instance: instance,
                id: this.state.data.id,
                lastestId : this.state.data.latestAccountTypePerson.id,
                status: status,
                account_type_id: event.target.account_type_id.value,
                profile_id: event.target.profile_id.value,
                file_retention: fileRetention ? 1 : 0,
                comment: comment,  
            }).then(res=>{
                location.reload();
            });
            // Handle success (e.g., show a success message)
        } catch (error) {
            // Handle error (e.g., show an error message)
        }
    }
    render() {
        const { data, companies, accountTypes,usersPerson,providers,accountTypeData,AccountTypePersonHistory,fileRetention,profiles,comment } = this.state;
        return (
            
            <div className="container">
                {this.props.success && (
                    <div className="alert alert-success mt-3">
                        {this.props.success}
                    </div>
                )}
                <div className="row">
                    <div className="col-md-12">
                        
                    </div>
                </div>

                <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                    <div className="row container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                        <div className="col-md-4 d-flex align-items-center flex-wrap">
                            <div className="symbol symbol-40 mr-5">
                                <div className="symbol-label bg-primary text-white font-weight-bolder">
                                    {data?.fiscal_name.substring(0, 2).toUpperCase()}
                                </div>
                            </div>
                            <h5 className="text-dark font-weight-bold my-1 mr-5">
                                {data?.fiscal_name}
                                <br />
                                {data?.country_id === 2 ? (
                                    <small className="text-muted font-weight-bold">RUT: {data?.rfc}</small>
                                ) : (
                                    <small className="text-muted font-weight-bold">RFC: {data?.rfc}</small>
                                )}
                            </h5>
                        </div>
                        <div className="col-md-2">
                            {data?.created} <br />
                            <span className="text-dark-50">Creación</span>
                        </div>
                        <div className="col-md-2">
                            {data?.latestAccountTypePerson.start_date} <br />
                            <span className="text-dark-50">Contratación</span>
                        </div>
                        <div className="col-md-2">
                            {data?.latestAccountTypePerson.expiration_date} <br />
                            <a href={`/admin/person/${data?.id}/edit?page=1&module=clients`} className="text-dark-50">Expiración</a>
                        </div>
                        <div className="col-md-2" style={{ textAlign: 'center' }}>
                            <span className={`badge badge-inline badge-pill ${
                                data?.latestAccountTypePerson.account_type_id === 1 ? 'badge-demo' :
                                data?.latestAccountTypePerson.account_type_id === 2 ? 'badge-compartida' :
                                data?.latestAccountTypePerson.account_type_id === 7 ? 'badge-compartida' :
                                data?.latestAccountTypePerson.account_type_id === 3 ? 'badge-local' :
                                data?.latestAccountTypePerson.account_type_id === 4 ? 'badge-success' :
                                data?.latestAccountTypePerson.account_type_id === 5 ? 'badge-comercial' : ''
                            }`}>
                                {data?.latestAccountTypePerson.account_type.title}
                            </span>
                            <br />Tipo de licencia
                        </div>
                    </div>
                </div>
                <div className="card card-custom gutter-b my-5">
                    <div className="card-header border-0 pt-6">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-size-h4 text-dark-50">Editar cuenta</span>
                            <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{data?.fiscal_name}</span>
                        </h3>
                    </div>
                    <div className="card-body pt-1">
                    <form method="POST" onSubmit={this.handleSubmit}  className="form-horizontal mt-3">
                            <div className="row">
                                <input type="hidden" name="people_id" value={data?.id} />
                                <div className="col-md-3 d-flex align-items-center gap-1">
                                    <label htmlFor="account_type_id" className="col-form-label">Status </label>
                                    <div className="d-flex">
                                        <div className="form-check mr-4">
                                            <input className="form-check-input" type="radio" name="status" id="vigente" value="Vigente" checked={this.state.status === 'Vigente'} onChange={this.handleStatusChange} />
                                            <label className="form-check-label" htmlFor="vigente">Vigente</label>
                                        </div>
                                        {this.state.status !== 'Expirado' && (
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="status" id="cancelado" value="Cancelado" checked={this.state.status === 'Cancelado'} onChange={this.handleStatusChange} />
                                                <label className="form-check-label" htmlFor="cancelado">Cancelado</label>
                                            </div>
                                        )}
                                    </div>
                                    {data?.latestAccountTypePerson?.status === 'Expirado' && (
                                        <span className="text-danger"> {data?.latestAccountTypePerson.status}</span>
                                    )}
                                </div> 
                                <div className="col-md-3 d-flex align-items-center gap-1">
                                    <p>Tipo de Licencia:</p>
                                    <div>
                                        <select name="account_type_id" id="account_type_id" className="form-control">
                                            {accountTypes?.map(accountType => (
                                                accountType.id !== 4 && (
                                                    <option key={accountType.id} value={accountType.id} selected={data?.latestAccountTypePerson.account_type_id === accountType.id}>
                                                        {accountType.title}
                                                    </option>
                                                )
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2 d-flex align-items-center gap-1">
                                    <p>Perfil</p>
                                    <div>
                                        <select name="profile_id" id="profile_id" className="form-control">
                                            {profiles?.map(profile => ( 
                                                    <option key={profile.id} value={profile.id} selected={data?.profile_id === profile.id}>
                                                        {profile.name}
                                                    </option> 
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <p>Conservar archivos:</p>
                                    <div>
                                    <input type="checkbox" name="file_retention" value="1" checked={fileRetention} onChange={this.handleCheckboxChange} />
                                     </div>
                                </div>
                                <div className="col-md-2">
                                    <button type="submit" id="submitButton" className="btn btn-sm btn-primary"  >Guardar cambios</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div> 
                    <div className="card card-custom gutter-b my-5">
                        <div className="card-header border-0 pt-6">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label font-weight-bolder font-size-h4 text-dark-75">Empresas del grupo</span>
                                <span className="text-muted mt-3 font-weight-bold font-size-lg">{companies.length} empresas</span>
                            </h3>
                        </div>
                        <div className="card-body pt-1">
                            <div className="table-responsive" style={{ maxHeight: '200px' }}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Empresa</th>
                                            <th>RFC</th>
                                            <th>Archivos</th>
                                            <th>Expedientes</th>
                                            <th>Invitados</th>
                                            <th>Estatus</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {companies.map(company => (
                                            <tr key={company.id}>
                                                <td>
                                                    <a className="text-primary" href={`/admin/person/${company.id}/show`}>{company.fiscal_name}</a>
                                                </td>
                                                <td>{company.rfc}</td>
                                                <td>{company.data.totalFiles} ({company.data.size} MB)</td>
                                                <td>{company.data.dossiers}</td>
                                                <td>{company.data.providers.length}</td>
                                                <td>
                                                    <span className={`${
                                                        company.data.status === 'Vigente' ? 'text-success' :
                                                        company.data.status === 'Expirado' ? 'text-danger' :
                                                        company.data.status === 'Cancelado' ? 'text-dark-50' :
                                                        ''
                                                    }`}>
                                                        {company.data.status}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div> 
                <div className="row">
                <div className="col-sm-6">
                    <div className="card card-custom gutter-b my-5">
                        <div className="card-header border-0 pt-6">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label font-weight-bolder font-size-h4 text-dark-75">Usuarios</span>
                                <span className="text-muted mt-3 font-weight-bold font-size-lg">{usersPerson?.length} usuarios</span>
                            </h3>
                        </div>
                        <div className="card-body pt-5">
                            <div className="table-responsive" style={{ maxHeight: '200px' }}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Usuario</th>
                                            <th>Perfil</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {usersPerson.map(userPerson => (
                                            <tr key={userPerson.id}>
                                                <td>{userPerson.user.email}</td>
                                                <td>{userPerson.role.title}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="card card-custom gutter-b my-5">
                        <div className="card-header border-0 pt-6">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label font-weight-bolder font-size-h4 text-dark-75">Invitados</span>
                                <span className="text-muted mt-3 font-weight-bold font-size-lg">{providers.length} invitados</span>
                            </h3>
                        </div>
                        <div className="card-body pt-5">
                            <div className="table-responsive" style={{ maxHeight: '200px' }}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Razón social</th>
                                            <th>Expedientes</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {providers.map(provider => (
                                            <tr key={provider.id}>
                                                <td>{provider.fiscal_name}</td>
                                                <td>
                                                    {provider.dossiers && provider.dossiers.map(prov => (
                                                        prov.dossier && <div key={prov.id}>{prov.dossier.title}<br /></div>
                                                    ))}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="card card-custom gutter-b my-5">
                        <div className="card-header border-0 pt-6">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label font-weight-bolder font-size-h4 text-dark-75">Historial de licenciamiento</span>
                            </h3>
                        </div>
                        <div className="card-body pt-5">
                            <div className="table-responsive" style={{ maxHeight: '200px' }}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Periodo</th>
                                            <th>Comentarios</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody> 
                                        {AccountTypePersonHistory?.map(accountTypePerson => (
                                            <tr key={accountTypePerson.id}>
                                                <td>
                                                    {accountTypePerson.account_type_id !== 4
                                                        ? `${accountTypePerson.start_date} - ${accountTypePerson.expiration_date}`
                                                        : `Desde ${accountTypePerson.start_date}`}
                                                </td>
                                                <td>
                                                    {accountTypePerson.comments.map(comment => (
                                                        <div className="card p-2" key={comment.id}>
                                                            <b className="text-primary">{comment.user.name}</b>
                                                            {comment.comment}
                                                            <p className="text-muted">{comment.created_at}</p>
                                                        </div>
                                                    ))}
                                                </td>
                                                <td>
                                                    {accountTypePerson.account_type_id !== 4 && (
                                                        <span className={`badge badge-inline badge-pill ${accountTypePerson.status === 'Vigente' ? 'badge-primary' : accountTypePerson.status === 'Expirado' ? 'badge-danger' : ''}`}>
                                                            {accountTypePerson.status}
                                                            {accountTypePerson.account_type_id === 1 && ` ${accountTypePerson.account_type.title}`}
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <form method="POST" onSubmit={this.handleSubmit} className="form-horizontal mt-3">
                                <div className="row">
                                    {/* Campos existentes... */}
                                    
                                    <div className="col-md-4 d-flex align-items-center gap-1">
                                        <label htmlFor="comment" className="col-form-label">Comentario</label>
                                        <textarea 
                                            name="comment" 
                                            id="comment" 
                                            className="form-control" 
                                            value={comment} 
                                            onChange={this.handleCommentChange} 
                                        />
                                    </div> 
                                    <div className="col-md-2">
                                        <button type="submit" id="submitButton" className="btn btn-sm btn-primary">Guardar cambios</button>
                                    </div>
                                </div>
                            </form> 
                        </div>
                    </div>
                </div>
            </div>
            </div>
        );
    }
}

export default DashboardAdminPerson;

if (document.getElementById('DashboardAdminPerson')) {
    ReactDOM.render(<DashboardAdminPerson />, document.getElementById('DashboardAdminPerson'));
}
